export class SidePanelResizeControl {
  isResizing: boolean;
  lastX: number;

  constructor(resizeControl?: Partial<SidePanelResizeControl>) {
    this.isResizing = resizeControl?.isResizing;
    this.lastX = resizeControl?.lastX;
  }
}
